<template>
  <div class="pControl">
    <p>Let me know you liked this project</p>

    <div class="react">
      <img src="../../assets/spinb.png" class="spin" ref="spin" />

      <div
        class="icon reaction"
        v-if="status && !stars"
        @click="reactionOneLess($event)"
        ref="trophless"
      >
        <i class="icofont-trophy"></i>
        <span>-1</span>
      </div>

      <div
        class="icon reaction"
        v-if="!status && !stars"
        @click="reactionPlusOne($event)"
        ref="trophplus"
      >
        <i class="icofont-trophy"></i>
        <span>+1</span>
      </div>

      <div
        class="icon reaction glow-on-hover"
        v-if="stars && !status"
        @click="reactionPlusOne($event)"
        ref="starplus"
      >
        <i class="icofont-ui-rating"></i>
        <span>Give +1</span>
      </div>

      <div
        class="icon reactionless"
        v-if="stars && status"
        @click="reactionOneLess($event)"
        ref="starless"
      >
        <i class="icofont-ui-rating"></i>
        <span>Remove star</span>
      </div>

      <p v-if="actionResult" :style="{margin: '10px 0 0 0', fontStyle: 'italic', fontSize: '13px'}">{{actionResult}}</p>
    </div>

    <div class="icon-holder" v-if="!stars">
      <div class="icon">
        <i class="icofont-trophy"></i>
      </div>
      <span>{{ statusText }}</span>
    </div>

    <div class="icon-holder" v-if="stars">
      <div class="icon">
        <i class="icofont-ui-rating"></i>
      </div>
      <span>{{ statusText }}</span>
    </div>

  </div>
</template>

<script>
import Request from '../../mixins/axiosRequest';
const delay = ms => new Promise(res => setTimeout(res, ms));

export default {
  props: {
    reactions: Array
  },

  data() {
    return {
      project: undefined,
      stars: false,
      actionResult: undefined,
      this_Client: undefined
    };
  },

  computed: {
    statusText() {
      return this.trophies(this.reactions[0]);
    },

    status() {
      return this.haveReacted(this.reactions[0]);
    }
  },

  methods: {
    trophies(val) {
      val = val.length;

      if (val == 0) {
        if (this.stars) {
          return "No stars yet.";
        }
        return "No trophies yet.";
      } else if (val == 1) {
        if (this.stars) {
          return `+${val} star gotten`;
        }
        return `+${val} trophy gotten`;
      } else {
        if (this.stars) {
          return `+${val} stars gotten`;
        }
        return `+${val} trophies gotten`;
      }
    },

    haveReacted(values) {
      if (values.includes(this.this_Client)) {
        return true;
      } else {
        return false;
      }
    },

    async reactionPlusOne() {
      let tropPlus = this.$refs.trophplus;
      let starPlus = this.$refs.starplus;
      
      starPlus.classList.add("pulseClass");
      await delay(600);

      let spin = this.$refs.spin;
      spin.style.display = "flex";

      if (this.stars) {
        starPlus.style.display = "none";
      } else {
        tropPlus.style.display = "none";
      }

      let res = await Request.axiosPost("/api/reactionadd", { id: this.project, index: this.stars }, this.client);

      if(res.status && res.code == 204) {
        spin.style.display = "none";
        this.actionResult = "Your star was added.";
        this.reactions[0].push(this.this_Client);
      } else {
        spin.style.display = "none";
        this.actionResult = "There was a problem and your star could not be added.";
        setTimeout(() => this.actionResult = undefined, 10000);
        if (this.stars) {
          starPlus.style.display = "flex";
        } else {
          tropPlus.style.display = "flex";
        }
      }
    },

    async reactionOneLess() {
      let tropLess = this.$refs.trophless;
      let starLess = this.$refs.starless;

      starLess.classList.add("pulseClass");
      await delay(600);

      let spin = this.$refs.spin;
      spin.style.display = "flex";

      if (this.stars) {
        starLess.style.display = "none";
      } else {
        tropLess.style.display = "none";
      }
      let res = await Request.axiosPost("/api/reactionrem", { id: this.project, index: this.stars }, this.client);

      if(res.status && res.code == 204) {
        spin.style.display = "none";
        this.actionResult = "Your star was removed.";
        let i = this.reactions.indexOf(this.this_Client);
        this.reactions[0].splice(i, 1);
      } else {
        spin.style.display = "none";
        this.actionResult = "There was a problem and your star could not be removed.";
        setTimeout(() => this.actionResult = undefined, 10000);
        if (this.stars) {
          starLess.style.display = "flex";
        } else {
          tropLess.style.display = "flex";
        }
      }
    }
  },

  async mounted() {
    this.project = this.reactions[1];

    this.reactions[2] == false ? this.stars = false : this.stars = true;

    this.this_Client = await this.client();
  }
};
</script>

<style scoped lang="scss">
p {
  margin-bottom: 10px;
  color: #000;
}

.pControl {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 5px;
}

i {
  font-size: 28px;
}

.icon {
  margin-top: 5px;
}

.icon-holder {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 15px 0;

  span {
    font-size: 18px;
  }
}

span {
  margin-left: 8px;
}

.react {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.pulseClass {
  box-shadow: 0 0 0 3.5em transparent;
  animation: pulse 1s;
}

.reaction, .reactionless {
  border: 1px solid #000;
  padding: 5px;
  margin-bottom: 0;

}

.reaction:hover {
  cursor: pointer;
}

.reactionless, .reactionless i, .reactionless span {
  transition: .7s;
  cursor: pointer;

}
.reactionless:hover {
  background-color: #000;
}

@keyframes pulse {
  0% { box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5); }
}

.glow-on-hover {
  position: relative;
  z-index: 0;
  
}

.glow-on-hover:before {
  content: '';
  background: linear-gradient(45deg, #ff0000, #ff7300, #fffb00, #48ff00, #00ffd5, #002bff, #7a00ff, #ff00c8, #ff0000);
  position: absolute;
  top: -4px;
  left:-4px;
  background-size: 400%;
  z-index: -1;
  filter: blur(5px);
  width: calc(100% + 8px);
  height: calc(100% + 8px);
  animation: glowing 20s linear infinite;
  opacity: 0;
  transition: opacity .3s ease-in-out;
}

.glow-on-hover:hover:before {
  opacity: 1;
}

.glow-on-hover:hover:after {
  background-color: rgb(0, 0, 0);
  
}

.glow-on-hover:after {
  z-index: -1;
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  transition: background-color .7s;

}

@keyframes glowing {
  0% { background-position: 0 0; }
  50% { background-position: 400% 0; }
  100% { background-position: 0 0; }
}

.reaction:hover i,
.reaction:hover span,
.reactionless:hover i,
.reactionless:hover span {
  color: rgb(224, 224, 224);
}

.reaction i, .reactionless i {
  font-size: 18px;
}

.reaction i, .reaction span {
  transition: color .7s;
}

.spin {
  display: none;
  height: 30px;
  animation: 2s rotate360 infinite linear;
}

@keyframes rotate360 {
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes rotate360 {
  to {
    transform: rotate(360deg);
  }
}
</style>
